
import { formatNumber } from "../../types/format";
import { computed, defineComponent, inject } from "vue";
import {
  FormValidatedValuesKey,
  FormValidatedUpdateKey,
  FormValidatedErrorsKey,
} from "../../types/inject";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    decimalPlaces: {
      type: Number,
      defaultValue: () => 2,
    },
    type: String,
    tclass: String,
  },
  emits: ["afterUpdate"],
  setup(props, { emit }) {
    const values = inject(FormValidatedValuesKey, {});
    const errors = inject(FormValidatedErrorsKey, {});

    const onUpdate = inject(FormValidatedUpdateKey);

    const aplicaMascara = (value: number) => {
      return formatNumber(value, props.decimalPlaces || 2, true);
    };

    const onChange = (event: Event) => {
      const { value } = event.target as HTMLInputElement;
      const decimalPlaces = props.decimalPlaces || 2;
      typeof onUpdate === "function" &&
        onUpdate({
          [props.name]:
            parseInt(`${value}`.replace(/[^0-9]/g, "")) / Math.pow(10, decimalPlaces),
        });
      emit(
        "afterUpdate",
        parseInt(`${value}`.replace(/[^0-9]/g, "")) / Math.pow(10, decimalPlaces)
      );
    };

    return {
      onChange,
      value: computed(() => aplicaMascara((values[props.name] || "") as number)),
      error: computed(() => errors[props.name]),
    };
  },
});
